export function formatDateAsMMDDYY(date: Date | string) {
  if (date === null || date === undefined) return null

  let _date
  if (typeof date === 'string') {
    _date = new Date(date)
  }

  try {
    const day = _date.getDate().toString().padStart(2, '0')
    const month = (_date.getMonth() + 1).toString().padStart(2, '0') // Months are 0-based
    const year = _date.getFullYear().toString().slice(-2) // Get last 2 digits of year

    return `${month}/${day}/${year}`
  } catch (error) {
    console.error(date, error)
    return null
  }
}
